import type { ActivityCockpitSnapshot } from '@internal/spassu-code-contract';
import type { CockpitHeaderView } from './cockpitViewModel';
import {
  activityStatusLabel,
  evidenceConditionLabel,
  sessionRuntimeLabel,
} from './semanticLabels';

export function createCockpitHeaderView(
  snapshot: ActivityCockpitSnapshot,
  viaLabel: string,
): CockpitHeaderView {
  const summary = snapshot.sections.summary;
  if (!summary.value) throw new Error('Cockpit summary is unavailable.');
  return {
    title: summary.value.activity.title,
    viaLabel,
    statusLabel: activityStatusLabel(summary.value.activity.status),
    evidenceLabel: evidenceConditionLabel(summary.status, summary.coverage),
    runtimeLabel: runtimeLabel(snapshot),
    updatedAt: snapshot.generatedAt,
    historical: snapshot.historical,
    revision: snapshot.revision,
  };
}

// The first binding names the runtime; an activity never mixes engines, and an
// absent sessions section (older snapshot) reads as unknown, not as a default.
function runtimeLabel(snapshot: ActivityCockpitSnapshot): string | null {
  const runtimeKind = snapshot.sections.sessions?.value?.[0]?.runtimeKind;
  return runtimeKind ? sessionRuntimeLabel(runtimeKind) : null;
}
